import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import ICONS from "../assets/Icons";
import { getAllCategories } from "../redux/features/sharedResources/sharedResources";
import { custom_category_base_url } from "./categoryIconMapper";

const DEFAULT_COLOUR = "var(--Custom-Category-Blue)";

const DEFAULT_ICON = {
  url: ICONS?.DEFAULT_CATEGORY,
  colour: null,
  isSvg: false,
};

// "Custom-Category-Blue" / "Custom_Category_Blue" -> css var; anything else -> default
const getColour = (colour) =>
  colour?.startsWith("Custom")
    ? `var(--${colour.replaceAll("_", "-")})`
    : DEFAULT_COLOUR;

const buildIcon = ({ asset_properties, logo_url }) => {
  const resource = asset_properties?.resource_name;

  if (resource) {
    return {
      url: `${custom_category_base_url}/${resource}`,
      colour: getColour(asset_properties?.colour),
      isSvg: true,
    };
  }
  return logo_url
    ? { url: logo_url, colour: null, isSvg: false }
    : DEFAULT_ICON;
};

/**
 * const getCategoryIcon = useCategories();
 * const { url, colour } = getCategoryIcon(transaction.category_id);
 */
export default function useCategories() {
  const dispatch = useDispatch();
  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  useEffect(() => {
    if (!categories?.length) dispatch(getAllCategories());
  }, [categories, dispatch]);

  const iconsById = useMemo(() => {
    const map = {};
    (categories ?? []).forEach((cat) => {
      map[String(cat.id)] = buildIcon(cat);
    });
    return map;
  }, [categories]);

  return (id) => iconsById[String(id)] ?? DEFAULT_ICON;
}
